import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP9BudgetCappedNew202602: FaireAdPerformancePeriodEntity = {
  token: "perf_p9_budget_capped_new_202602",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-02-01",
  endDate: "2026-02-28",
  impressions: 44964,
  clicks: 914,
  adsSpendDollars: 2341,
  budgetDollars: 4000,
  salesDollars: 15716,
  bestEstimateRoas: 6.71,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.59,
  newCustomersAcquired: 49,
  dataAvailableAtDate: "2026-03-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
